// extracted by mini-css-extract-plugin
export var body = "index-module--body--OP7qJ";
export var container = "index-module--container--GJolL";
export var details = "index-module--details--+vvqO";
export var heroImage = "index-module--heroImage--BNKWm";
export var invertedColorScheme = "index-module--invertedColorScheme--41OTJ";
export var label = "index-module--label--4qi+y";
export var mobileBody = "index-module--mobileBody--BjCXV";
export var mobileHeader = "index-module--mobileHeader--qIWlG";
export var mobileOnly = "index-module--mobileOnly--2IWnx";
export var nonmobile = "index-module--nonmobile--7Vc2k";
export var os1Title = "index-module--os1Title--5VbfA";
export var osTitle = "index-module--osTitle--3MARD";
export var talkToSales = "index-module--talkToSales--p9PNl";
export var title = "index-module--title--8Ap-T";
export var tts = "index-module--tts--py8cQ";